import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import usePromotions from "common/datahooks/usePromotions";
import { get } from "common/helpers/HTTP";

import type { Invoice } from "../types";

async function getAgencyInvoices(workspaceId: string): Promise<Invoice[]> {
  return (await get(`subscriptions/invoices`)).invoices;
}

export default function useAgencyInvoices() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { agencyPlan } = usePromotions();
  const { agency } = getQueryKeys(workspaceId);

  const {
    data: agencyInvoices,
    isLoading: isLoadingAgencyInvoices,
    isError: isAgencyInvoicesError,
    refetch: refetchAgencyInvoices,
  } = useQuery({
    queryKey: agency.invoices(),
    queryFn: () => getAgencyInvoices(workspaceId),
    enabled: !!agencyPlan,
  });

  return {
    agencyInvoices,
    isLoadingAgencyInvoices,
    isAgencyInvoicesError,
    refetchAgencyInvoices,
  };
}
